import { Link } from "react-router-dom";
import { NewsletterSignup } from "../shared/NewsletterSignup";

const COLS = [
  {
    title: "Topics",
    links: [
      { to: "/borrow", label: "Borrow" },
      { to: "/invest", label: "Invest" },
      { to: "/business", label: "Business" },
      { to: "/real-estate", label: "Real Estate" },
      { to: "/vehicles", label: "Vehicles" },
    ],
  },
  {
    title: "Tools & Content",
    links: [
      { to: "/calculators", label: "Calculators" },
      { to: "/articles", label: "Articles" },
      { to: "/pricing", label: "Pricing" },
      { to: "/ai", label: "AI Tools" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
      { to: "/editorial-policy", label: "Editorial Policy" },
      { to: "/advertising-disclosure", label: "Advertising Disclosure" },
      { to: "/how-we-make-money", label: "How We Make Money" },
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Service" },
      { to: "/disclaimer", label: "Disclaimer" },
    ],
  },
];

export function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-[#F8FAF9]" id="newsletter">
      <div className="mml-container py-16 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="grid h-8 w-8 place-items-center rounded-lg bg-emerald-700 text-white">
                <span className="font-bold">M</span>
              </span>
              <span className="text-lg font-bold tracking-tight text-slate-900">
                MyMoneyLocal
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm text-slate-600">
              Personal finance education and calculators that help you make
              better money decisions. Plain English. No nonsense.
            </p>
            <div className="mt-6 max-w-md">
              <NewsletterSignup
                compact
                sourcePage="footer"
                heading="Get smarter with your money."
                subheading="One short, practical email per week. Unsubscribe anytime."
                idScope="footer"
              />
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <h3 className="text-sm font-semibold uppercase tracking-wider text-slate-900">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-2">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-slate-600 transition-colors hover:text-emerald-700"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-slate-200 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center">
          <p>
            © {new Date().getFullYear()} MyMoneyLocal. Educational content
            only — not financial advice.
          </p>
          <p>Built for clear-headed money decisions.</p>
        </div>
      </div>
    </footer>
  );
}
